import { useEffect, useState } from 'react';
import { featuresReadyPromise } from '../constants/growthbook';

// Safety release if loadFeatures() hangs (blocked CDN / offline) so the
// authenticated boot splash never waits forever on flags.
const FEATURE_FLAGS_TIMEOUT_MS = 1000;

// Non-blocking readiness signal for GrowthBook features. Replaces the old
// render-blocking FeatureFlagsGate: instead of gating the whole app (login
// included) behind a flags fetch, the authenticated boot splash folds this
// into its single resolve condition so flags load in PARALLEL with the
// session — and public routes, which read no flags, render immediately.
//
// `featuresReadyPromise` is kicked off at module load, so by the time a
// gated route mounts the fetch is usually already in flight or settled.
export const useFeaturesReady = (): boolean => {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		let cancelled = false;
		featuresReadyPromise.finally(() => {
			if (!cancelled) setReady(true);
		});
		const timeoutId = window.setTimeout(() => {
			if (!cancelled) setReady(true);
		}, FEATURE_FLAGS_TIMEOUT_MS);

		return () => {
			cancelled = true;
			window.clearTimeout(timeoutId);
		};
	}, []);

	return ready;
};

export default useFeaturesReady;
